export default function MediaSection() {
  const items = [
    {
      title: '暑期档必看：2026年最受期待的十部大片',
      desc: '从超级英雄到科幻巨制，从国产力作到好莱坞重磅，盘点今年暑期档最值得关注的影片。',
      duration: '专题策划',
      img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20blockbuster%20visual%20with%20explosive%20action%20elements%2C%20warm%20golden%20sunset%20lighting%2C%20epic%20movie%20montage%20style%2C%20dark%20dramatic%20background%20with%20amber%20highlights%2C%20professional%20cinema%20aesthetic%2C%20no%20text&width=600&height=340&seq=media-1-summer-preview&orientation=landscape',
    },
    {
      title: '豆瓣高分华语剧推荐：口碑炸裂不容错过',
      desc: '整理近期豆瓣评分8.5以上的国产精品剧集，从悬疑到都市，总有一部适合你。',
      duration: '编辑精选',
      img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20TV%20drama%20visual%20with%20warm%20indoor%20lighting%2C%20cozy%20living%20room%20scene%2C%20cinematic%20composition%2C%20soft%20golden%20and%20warm%20tones%2C%20artistic%20photography%20style%2C%20no%20text%2C%20clean%20simple%20background&width=600&height=340&seq=media-2-douban-drama&orientation=landscape',
    },
    {
      title: '周末观影指南：适合全家人一起看的温馨好片',
      desc: '精选适合家庭观影的温馨喜剧与动画电影，让周末时光充满欢笑和感动。',
      duration: '观影指南',
      img: 'https://readdy.ai/api/search-image?query=Warm%20family%20movie%20night%20visual%20with%20cozy%20living%20room%20and%20soft%20glowing%20TV%20screen%2C%20golden%20evening%20atmosphere%2C%20cinematic%20composition%2C%20warm%20inviting%20lighting%2C%20dark%20cozy%20background%2C%20no%20text&width=600&height=340&seq=media-3-family-movie&orientation=landscape',
    },
  ];

  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            精彩推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            编辑精选的观影推荐与专题策划，帮你找到下一部心头好
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {items.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent"></div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-background-50/90 rounded-full group-hover:bg-primary-500 transition-colors duration-300">
                  <i className="ri-play-line text-lg text-primary-500 group-hover:text-background-50 transition-colors duration-300 ml-0.5"></i>
                </div>
                <span className="absolute bottom-3 left-3 px-2.5 py-1 text-xs font-medium bg-foreground-950/70 text-background-50 rounded-full whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}